import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { WhatsAppChatComponent } from './chat/whatsapp-chat.component';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextarea } from 'primeng/inputtextarea';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { Dialog, DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';

 
@NgModule({
    declarations: [	
        WhatsAppChatComponent
   ],
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        ButtonModule,
        DatePipe,
        DropdownModule,
        InputTextarea,
        MessagesModule,
        DialogModule,
        TooltipModule,
        InputTextModule,
        OverlayPanelModule
    ],
    providers: []
})
export class WhatsAppModule { }